<template>
  <a-popconfirm title="此操作将强制刷新页面，并清理缓存，您确定执行吗?" ok-text="确定" cancel-text="取消" @confirm="confirm" @cancel="cancel">
    <a-badge>
      <a-icon v-if='this.renewal' slot="count" type="clock-circle" style="color: #f5222d" />
      <div class="cache-box">
        <span class="cache-box-icon">
          <a-icon type="cloud-sync" />
        </span>
        <div>清缓存</div>
      </div>
    </a-badge>
  </a-popconfirm>
</template>

<script>
import { toClearCache } from '@/utils/utils';
import MqttClient from '@/utils/MqttClient';

export default {
  data() {
    return {
      mq: null,
      assemble: [
        {
          name: 'linggekj',
          keys: [
            'infra-web-authority',
            'infra-web-workflow',
            'infra-web-cli',
            'infra-web-message',
            'infra-web-admin',
            'infra-web-base',
          ],
          appId: '90001',
        },
      ],
      renewal: !!localStorage.getItem('Renewal'),
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // this.mq = new MqttClient();
      // this.mq.subscribeTopic('servicePushMqttTopic');
      // this.mq.receiveMessageWithTopic((topic, msg) => {
      //   try {
      //     const msglist = JSON.parse(msg);
      //     if (msglist && msglist.tag) {
      //       const releases = localStorage.getItem('ZNMONITOR_RELEASE') ? JSON.parse(localStorage.getItem('ZNMONITOR_RELEASE')) : {};
      //       releases[msglist.key || msglist.serviceName || 'error'] = msglist.tag;
      //       localStorage.setItem('ZNMONITOR_RELEASE', JSON.stringify(releases));
      //     }

      //     this.cacheIdentifier(msglist);
      //   } catch (error) {
      //   }
      // });
    },
    cacheIdentifier(val) {
      if (!val.key) {
        return;
      }
      let keys = [];
      const urls = window.location.hostname.toString();
      this.assemble.forEach((em) => {
        if (urls.indexOf(em.name) !== -1 && em.appId === localStorage.getItem('appId')) {
          keys = em.keys;
        }
      });
      keys.forEach((im) => {
        // eslint-disable-next-line eqeqeq
        if (val.key == im) {
          localStorage.setItem('Renewal', '1');
          this.renewal = true;
        }
      });
    },
    confirm() {
      toClearCache();
    },
    cancel(e) {
      console.log(e);
    },
  },
};
</script>
<style lang="less" scoped>
.ant-badge {
  margin-right: 24px;
}

.cache-box {
  cursor: pointer;
  display: flex;
  font-size: 14px;
  width: 80px;

  &-icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    font-size: 24px;
    margin-right: 4px;
    position: relative;

    i {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
  }

  div {
    flex: 1;
    color: #333333;
    vertical-align: middle;
    text-align: center;
    line-height: 24px;
  }
}
</style>
<style>
.ant-btn-primary {
  background-color: #3673ff;
  border-color: #3673ff;
}
</style>
